import React from "react";
import PropTypes from "prop-types";

/**
 * AssetAllocationBars Component
 *
 * Displays asset allocation as horizontal bars with percentages and asset names
 *
 * @param {Object} props - Component props
 * @param {Array} props.assets - Array of asset objects with name, percentage, and color
 */
const AssetAllocationBars = ({
  assets = [
    { name: "NVDA", percentage: "20.00%", color: "#1e40af" },
    { name: "AAPL", percentage: "18.00%", color: "#3b82f6" },
    { name: "AMZN", percentage: "15.00%", color: "#60a5fa" },
    { name: "MA", percentage: "14.00%", color: "#93c5fd" },
    { name: "MSFT", percentage: "12.00%", color: "#bfdbfe" },
    { name: "TSLA", percentage: "10.00%", color: "#dbeafe" },
    { name: "V", percentage: "8.00%", color: "#f0f9ff" },
  ],
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "0.5rem",
      }}
    >
      {/* Asset Allocation Bars */}
      <div
        style={{
          display: "flex",
          height: "8px",
          borderRadius: "4px",
          gap: "2px",
          backgroundColor: "#f3f4f6",
          padding: "2px",
        }}
      >
        {assets.map((asset) => {
          const width = parseFloat(asset.percentage.replace("%", ""));

          return (
            <div
              key={asset.symbol || asset.name || asset.id}
              style={{
                width: `${width}%`,
                backgroundColor: asset.color,
                height: "100%",
                borderRadius: "2px",
              }}
            />
          );
        })}
      </div>

      {/* Asset Cards */}
      <div
        style={{
          display: "flex",
          gap: "0.5rem",
          flexWrap: "wrap",
          width: "100%",
        }}
      >
        {assets.map((asset) => (
          <div
            key={asset.symbol || asset.name || asset.id}
            style={{
              backgroundColor: "#ffffff",
              border: "1px solid #e5e7eb",
              borderLeft: `4px solid ${asset.color}`,
              borderRadius: "4px",
              padding: "8px 12px",
              minWidth: "100px",
              maxWidth: "140px",
              flex: "1 1 auto",
              display: "flex",
              flexDirection: "column",
              gap: "4px",
              whiteSpace: "nowrap",
            }}
          >
            <div
              style={{
                fontSize: "14px",
                fontWeight: "600",
                color: "#1f2937",
              }}
            >
              {asset.symbol || asset.name || asset.id || "N/A"}
            </div>
            <div
              style={{
                fontSize: "12px",
                color: "#6b7280",
              }}
            >
              {asset.percentage}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

AssetAllocationBars.propTypes = {
  assets: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      percentage: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
    })
  ),
};

export default AssetAllocationBars;
